import styles from '../styles/Archives.module.css';

const DescBlack = ({text}) => {
    return <div className={styles.descBlack}>{text}</div>
};

export default DescBlack;